import 'bootstrap-5.1.3.bundle.min.js';
import 'bootstrap-5.1.3.min.css';
import '@fortawesome/fontawesome-free/js/all.js';
import '@fortawesome/fontawesome-free/css/all.css';
import cssVars from 'css-vars-ponyfill';
import getAmplifyConfiguration from '../components/cognito/amplifyConfiguration';
import { Amplify } from 'aws-amplify';
import { signOut } from 'aws-amplify/auth';
import 'blueimp-file-upload/js/jquery.iframe-transport.js';
import 'blueimp-file-upload/js/jquery.fileupload.js';
import 'blueimp-file-upload/js/jquery.fileupload-image.js';
import 'blueimp-file-upload/js/jquery.fileupload-ui.js';
import './wrappers';
import 'jquery-ui/ui/widgets/autocomplete';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import Echo from 'laravel-echo';
import 'pusher-js';
/* @ts-ignore */
import { trackEvent } from '@shared/helpers';
library.add(fas, far);
require('jquery-validation');
require('jquery-validation/dist/additional-methods.js');
require('phone.number');
require('Raleway.css');
require('jquery-ui');
require('jquery-datetimepicker');
require('blueimp-file-upload');
require('jquery-ui/dist/themes/base/jquery-ui.min.css');
require('jquery-datetimepicker/jquery.datetimepicker.css');
//Remove this once IE11 is no longer supported, as this provides support for css custom properties to IE11.
cssVars({
    watch: true,
});
//Add CSRF header to AJAX requests.
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    },
});
//Add CSRF info to submitted forms.
$(document).on('submit', 'form', function () {
    var token = $('meta[name="csrf-token"]').attr('content');
    if ($(this).children('input[name="_token"]').length > 0) {
        //This form already has the CSRF token appended, no need to do anything.
        return;
    }
    $(this).append('<input type="hidden" name="_token" value="' + token + '"/>');
});
function serviceContactPopup(serviceId, bySubmit) {
    // Logic to toggle visibility of sections based on bySubmit parameter
    // bySubmit = 1: Show the "By submitting this form" message
    if (bySubmit === 1) {
        $('#restricted_to_EEU').addClass('d-none');
        $('.bySubmitMsg').removeClass('d-none');
        // bySubmit = 2: Show the "Restricted to EEU" message
    }
    else if (bySubmit === 2) {
        $('.bySubmitMsg').addClass('d-none');
        $('#restricted_to_EEU').removeClass('d-none');
        // bySubmit = 0: Show neither message
    }
    else {
        $('.bySubmitMsg').addClass('d-none');
        $('#restricted_to_EEU').addClass('d-none');
    }
    trackSearchClick('View Organization Contact Information');
    $('#contact_modal')
        .modal()
        .find('.modal-body')
        .load(route('serviceContactPopup', { service: serviceId }), function () {
        $('#contact_modal').modal('show');
    });
}
var auth = getAmplifyConfiguration();
Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: auth.userPoolId,
            userPoolClientId: auth.userPoolWebClientId,
        },
    },
});
window.amplifyAuth = { signOut: signOut };
function signOut_() {
    window.amplifyAuth.signOut();
}
window.signOut = signOut_;
window.serviceContactPopup = serviceContactPopup;
window.laravelEcho = Echo;
// Global function to call trackEvent
window.trackSearchClick = function (eventName, properties, andThen) {
    if (properties === void 0) { properties = {}; }
    if (andThen === void 0) { andThen = null; }
    trackEvent(eventName, properties, andThen);
};
